import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React from 'react';
import { colors, spacing } from '../../../utils/styleguide';
import Icon, { IconNames } from '../Icon';

const StyledButton = styled.button<{
  variant: 'filled' | 'onlyIcon';
  width?: number;
  height?: number;
  buttonColor?: string;
  hoverButtonColor?: string;
}>`
  cursor: pointer;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  background: none;
  :disabled {
    cursor: default;
  }
  ${({ variant, width, height, buttonColor, hoverButtonColor }) =>
    variant === 'filled'
      ? css`
          border-radius: ${spacing[4]}px;
          width: ${width || spacing[7]}px;
          height: ${height || spacing[7]}px;
          background-color: ${buttonColor || colors.black};

          :hover {
            background-color: ${hoverButtonColor || '#2c2e3a'};
          }

          :focus {
            box-shadow: 0 0 0 2px ${colors.yellow}, 0 0 0 3px ${colors.black};
          }
          :disabled {
            background-color: ${colors.lightGrey};
          }
        `
      : ''}
`;

type Props = {
  className?: string;
  iconName: IconNames;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  variant?: 'filled' | 'onlyIcon';
  stroke?: string;
  fill?: string;
  ariaLabel: string;
  disabled?: boolean;
  iconSize?: number;
  desktopIconSize?: number;
  width?: number;
  height?: number;
  buttonColor?: string;
  hoverButtonColor?: string;
};

const IconButton = ({
  iconName,
  className,
  onClick,
  variant = 'filled',
  stroke,
  ariaLabel,
  disabled = false,
  iconSize,
  desktopIconSize,
  width,
  height,
  buttonColor,
  hoverButtonColor,
  fill,
}: Props) => {
  let defaultColor = colors.black;
  if (variant === 'filled') {
    defaultColor = colors.white;
  }
  if (variant === 'onlyIcon' && disabled) {
    defaultColor = colors.lightGrey;
  }

  return (
    <StyledButton
      className={className}
      onClick={onClick}
      variant={variant}
      aria-label={ariaLabel}
      disabled={disabled}
      width={width}
      height={height}
      buttonColor={buttonColor}
      hoverButtonColor={hoverButtonColor}
    >
      <Icon
        name={iconName}
        size={iconSize || 24}
        desktopSize={desktopIconSize}
        stroke={stroke || defaultColor}
        fill={fill}
      />
    </StyledButton>
  );
};

export default IconButton;
